import { observer } from 'mobx-react-lite'
import { type FC, useState, useRef, useEffect } from 'react'
import { Button, Typography } from 'shared/ui'
import { type CannedMessage } from 'entities/CannedMessages/model/CannedMessage'
import { IconSharedSavedReply } from 'entities/CannedMessages'
import { SavedReplyActions } from 'widgets/SavedReplies/ui/SavedRepliesContent/SavedReplyActions/SavedReplyActions'
import { useSavedRepliesContext } from 'widgets/SavedReplies/context'
import styles from './styles.module.scss'

type ISavedReplyItemProps = {
  item: CannedMessage
}

export const SavedReplyItem: FC<ISavedReplyItemProps> = observer(({ item }) => {
  const ref = useRef<HTMLButtonElement>(null)
  const [hover, setHover] = useState(false)
  const store = useSavedRepliesContext()
  const {
    selectedSavedReply,
    setSelectSavedReply,
    visibleSavedRepliesActionsId,
    handleAddSavedReplies,
    setSelectedSavedReplyRef,
    setUseScrollToElement,
  } = store
  const onClick = () => {
    setSelectSavedReply(item)
    handleAddSavedReplies(item)
  }
  const onMouseEnter = () => {
    setHover(true)
    setSelectSavedReply(item)
    setUseScrollToElement(false)
  }
  const onMouseLeave = () => {
    setHover(false)
  }

  useEffect(() => {
    if (selectedSavedReply?.id === item.id) {
      setSelectedSavedReplyRef(ref)
    }
  }, [selectedSavedReply])

  return (
    <Button
      ref={ref}
      typeBtn={'inbox'}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      titleContent={
        <div className={styles.wrap}>
          <Typography variant={'body-md-regular'} ellipsis ariaLabel={'title'}>
            {item.title}
          </Typography>
          <IconSharedSavedReply savedReply={item} iconProps={{ fontSize: 12 }} />
          {(hover || visibleSavedRepliesActionsId === item.id) && (
            <div className={styles.actions}>
              <SavedReplyActions
                savedReply={item}
                tooltipParentElement={store.leftContentElement}
                collapsed
              />
            </div>
          )}
        </div>
      }
      active={selectedSavedReply?.id === item.id}
    />
  )
})
